export enum OperatorType {
  Plus = 1,
  Minus = 2,
}

export enum SocketOperations {
  Create = '1',
  Update = '2',
  Delete = '3',
}
